import React, { useEffect, useRef, useState } from "react";
import "./Test_Page.css";
import { Button, Form, Pagination, Spinner } from "react-bootstrap";
import Common_Btn from "../common/common-btn/Common_Btn";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Success_Modal from "../modals/success-modal/Success_Modal";
import { useDispatch, useSelector } from "react-redux";

import {
  FinalSubmit,
  GetAllExamQuestion,
  StudentResponse,
} from "../../redux/get_exam_questions";
import { GetAllUserTest } from "../../redux/profile";
import { useForm } from "react-hook-form";

const Test_Page = () => {
  const isSubmittedRef = useRef(false);
  const location = useLocation();
  const prevLocationRef = useRef(location);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const intervalRef = useRef(null);

  // const storageKeyRef = useRef("languageTestEndTime");

  const { id } = useParams();

  const storageKeyRef = useRef(`languageTestEndTime_${id}`);

  const [errorMsg, setErrorMsg] = useState("");

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [showModal, setShowModal] = useState(false);
  const [answers, setAnswers] = useState({}); // ✅ store answers

  const all_questions = useSelector((state) => state?.get_exam_questions);

  const questions = [...(all_questions?.data || [])].sort(
    (a, b) => a.id - b.id,
  );

  // ✅ Loader flags — derived from slice status + local saving flag
  // NOTE: must come AFTER `questions` is declared (TDZ otherwise)
  const questionsStatus = all_questions?.status;
  const isQuestionsLoading =
    questionsStatus === "loading" && questions.length === 0;
  const isPageSwitching =
    questionsStatus === "loading" && questions.length > 0;
  const [isSaving, setIsSaving] = useState(false);
  const [isSubmittingFinal, setIsSubmittingFinal] = useState(false);

  // let currentPage = all_questions?.current_page || 1;

  const [page, setPage] = useState(1);

  const currentPage = page;

  const currentQuestion = questions[currentPage - 1];

  // const totalPages = all_questions?.total_pages || 1;

  const totalPages = questions.length || 1;

  const timeDuration = all_questions?.data?.[0]?.User_Exam?.Exam?.time || 0;

  const initialSeconds = Number(timeDuration) * 60;

  const [timeLeft, setTimeLeft] = useState(0);

  const [isStarted, setIsStarted] = useState(false);

  // useEffect(() => {
  //   const handleBeforeUnload = (e) => {
  //     if (!isSubmittedRef.current) {
  //       e.preventDefault();
  //       e.returnValue = ""; // required for browser popup
  //     }
  //   };

  //   window.addEventListener("beforeunload", handleBeforeUnload);

  //   return () => {
  //     window.removeEventListener("beforeunload", handleBeforeUnload);
  //   };
  // }, []);

  // useEffect(() => {
  //   const handleUnload = () => {
  //     if (!isSubmittedRef.current) {
  //       handleSubmitFinal(); // try submit
  //     }
  //   };

  //   window.addEventListener("unload", handleUnload);

  //   return () => {
  //     window.removeEventListener("unload", handleUnload);
  //   };
  // }, []);

  // useEffect(() => {
  //   const handleKeyDown = (e) => {
  //     // Detect Windows + Shift + S (Snipping Tool)
  //     if (
  //       e.shiftKey &&
  //       (e.metaKey || e.key === "Meta") &&
  //       e.key.toLowerCase() === "s"
  //     ) {
  //       e.preventDefault();
  //       e.stopPropagation();

  //       alert("Screenshot is not allowed during the exam");

  //       handleSubmitFinal(); // optional strict action
  //       return;
  //     }

  //     // ✅ ALSO detect PrintScreen
  //     if (e.key === "PrintScreen") {
  //       e.preventDefault();
  //       alert("Screenshot is not allowed");
  //       handleSubmitFinal();
  //       return;
  //     }
  //   };

  //   window.addEventListener("keydown", handleKeyDown, true);

  //   return () => {
  //     window.removeEventListener("keydown", handleKeyDown, true);
  //   };
  // }, []);

  useEffect(() => {
    const preventCopy = (e) => {
      e.preventDefault();
      alert("Copy is not allowed during the exam");
    };

    const preventPaste = (e) => {
      e.preventDefault();
      alert("Paste is not allowed");
    };

    const preventCut = (e) => {
      e.preventDefault();
    };

    const preventSelect = (e) => {
      e.preventDefault();
    };

    document.addEventListener("copy", preventCopy);
    document.addEventListener("paste", preventPaste);
    document.addEventListener("cut", preventCut);
    document.addEventListener("selectstart", preventSelect);

    return () => {
      document.removeEventListener("copy", preventCopy);
      document.removeEventListener("paste", preventPaste);
      document.removeEventListener("cut", preventCut);
      document.removeEventListener("selectstart", preventSelect);
    };
  }, []);

  useEffect(() => {
    const preventDrag = (e) => e.preventDefault();

    document.addEventListener("dragstart", preventDrag);

    return () => {
      document.removeEventListener("dragstart", preventDrag);
    };
  }, []);

  const startTest = async () => {
    try {
      await document.documentElement.requestFullscreen();
    } catch (err) {
      console.log(err);
    }
    setIsStarted(true);
  };

  useEffect(() => {
    if (!initialSeconds) return;

    let storedEndTime = localStorage.getItem(storageKeyRef.current);

    if (!storedEndTime) {
      const newEndTime = Date.now() + initialSeconds * 1000;
      localStorage.setItem(storageKeyRef.current, newEndTime);
      storedEndTime = newEndTime;
    }

    const updateTimer = () => {
      const remaining = Math.max(
        Math.floor((storedEndTime - Date.now()) / 1000),
        0,
      );

      setTimeLeft(remaining);

      if (remaining <= 0) {
        clearInterval(intervalRef.current);
        localStorage.removeItem(storageKeyRef.current);
        handleSubmitFinal();
      }
    };

    intervalRef.current = setInterval(updateTimer, 1000);
    updateTimer();

    return () => clearInterval(intervalRef.current);
  }, [initialSeconds]);

  useEffect(() => {
    const handleRightClick = (e) => {
      e.preventDefault();
    };

    document.addEventListener("contextmenu", handleRightClick);

    return () => {
      document.removeEventListener("contextmenu", handleRightClick);
    };
  }, []);

  const {
    register,
    handleSubmit,
    reset,
    watch,
    control,
    formState: { errors, isSubmitting },
    getValues,
  } = useForm({
    defaultValues: {
      user_answer_id: all_questions?.data?.[0]?.user_answer_id || "",
    },
  });

  // const fetch = async (page = all_questions?.current_page) => {
  //   await dispatch(
  //     GetAllExamQuestion({
  //       id: id,
  //       page: page,
  //       per_page: 1,
  //     }),
  //   );
  // };

  const fetch = async () => {
    await dispatch(
      GetAllExamQuestion({
        id: id,
        per_page: 1000, // ✅ GET ALL QUESTIONS
      }),
    );
  };

  // const handlePageChange = (page) => {
  //   if (page !== currentPage) {
  //     fetch(page);
  //   }
  // };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setPage(newPage);
    }
  };

  useEffect(() => {
    fetch();
  }, []);

  const handleSave = async () => {
    try {
      const currentQuestion = questions[currentPage - 1];

      if (!currentQuestion) return;

      const selectedAnswer = answers[currentQuestion.id];

      if (!selectedAnswer) {
        setErrorMsg("Please select an option before saving.");
        return;
      }

      setErrorMsg(""); // clear error
      setIsSaving(true);

      const response = await dispatch(
        StudentResponse({
          id: currentQuestion.id,
          user_answer_id: selectedAnswer,
        }),
      );

      if (response.meta?.requestStatus === "fulfilled") {
        // fetch();
        // if (currentPage < totalPages) {
        //   await fetch(currentPage + 1);
        // }
        await dispatch(
          GetAllExamQuestion({
            id: id,
            per_page: 1000, // ✅ GET ALL QUESTIONS
          }),
        );
        if (currentPage < totalPages) {
          setPage(currentPage + 1); // ✅ CORRECT
        }
      } else {
        setErrorMsg(response?.payload?.message || "Failed to save answer. Please try again.");
      }
    } catch (error) {
      console.error(error);
      setErrorMsg("Failed to save answer. Please try again.");
    } finally {
      setIsSaving(false);
    }
  };

  // useEffect(() => {
  //   const current = all_questions?.data?.[0];

  //   if (current?.user_answer_id) {
  //     setAnswers((prev) => ({
  //       ...prev,
  //       [current.id]: current.user_answer_id,
  //     }));
  //   }
  // }, [all_questions]);

  useEffect(() => {
    setAnswers((prev) => {
      const updated = { ...prev };

      questions.forEach((q) => {
        if (q.user_answer_id && !updated[q.id]) {
          updated[q.id] = q.user_answer_id;
        }
      });

      return updated;
    });
  }, [all_questions]);

  // useEffect(() => {
  //   if (questions.length > 0) {
  //     setPage(1);
  //   }
  // }, [all_questions]);

  const handleSubmitFinal = async () => {
    //   if (isSubmittedRef.current) return;

    //   isSubmittedRef.current = true;
    //   setIsSubmitted(true);

    //   clearInterval(intervalRef.current);
    //   localStorage.removeItem(storageKeyRef.current);
    //   localStorage.removeItem("forceSubmit");

    //  console.log(currentQuestion,"currentQuestion currentQuestion final");

    //   if (!currentQuestion) return;
    //   console.log("after condition");

    const selectedAnswer = answers[currentQuestion?.id];

    const data = {
      id,
      question_id: currentQuestion?.id,
      user_answer_id: selectedAnswer,
    };

    setIsSubmittingFinal(true);
    try {
      const response = await dispatch(FinalSubmit(data));

      if (response.payload?.success) {
        // ✅ Sync attended list BEFORE leaving, then SPA-navigate (no full reload)
        try {
          await dispatch(GetAllUserTest());
        } catch (e) {
          console.error("Failed to refresh attended tests:", e);
        }
        try {
          if (document.fullscreenElement) await document.exitFullscreen();
        } catch (e) {
          console.warn("Could not exit fullscreen:", e);
        }
        setShowModal(true);

        setTimeout(() => {
          navigate("/test-instructions");
        }, 1500);
      } else {
        setErrorMsg(response?.payload?.message || "Failed to submit test. Please try again.");
      }
    } catch (error) {
      console.error(error);
      setErrorMsg("Failed to submit test. Please try again.");
    } finally {
      setIsSubmittingFinal(false);
    }
  };

  // Strong Anti-Cheating Key Blocker
  // useEffect(() => {
  //   const blockKeys = (e) => {
  //     // Block F1 to F12
  //     if (e.key.startsWith("F") && e.key.length > 1) {
  //       e.preventDefault();
  //       e.stopImmediatePropagation();
  //       return false;
  //     }

  //     // Block Escape
  //     if (e.key === "Escape") {
  //       e.preventDefault();
  //       e.stopImmediatePropagation();
  //       return false;
  //     }

  //     // Block Alt (including AltGr)
  //     if (e.altKey) {
  //       e.preventDefault();
  //       e.stopImmediatePropagation();
  //       return false;
  //     }

  //     // Block Ctrl + anything (most dangerous shortcuts)
  //     if (e.ctrlKey) {
  //       e.preventDefault();
  //       e.stopImmediatePropagation();
  //       return false;
  //     }

  //     // Block Meta key (Cmd on Mac)
  //     if (e.metaKey) {
  //       e.preventDefault();
  //       e.stopImmediatePropagation();
  //       return false;
  //     }

  //     // Block specific dangerous combinations
  //     const dangerousKeys = ["i", "j", "u", "s", "p", "r", "t", "w", "Tab"];
  //     if (e.ctrlKey || e.shiftKey || e.altKey) {
  //       if (dangerousKeys.includes(e.key.toLowerCase())) {
  //         e.preventDefault();
  //         e.stopImmediatePropagation();
  //       }
  //     }

  //     // Block Shift + specific keys that open dev tools or menus
  //     if (e.shiftKey && (e.key === "I" || e.key === "J" || e.key === "C")) {
  //       e.preventDefault();
  //       e.stopImmediatePropagation();
  //     }
  //   };

  //   // Add listeners with capture phase for better priority
  //   window.addEventListener("keydown", blockKeys, true);
  //   window.addEventListener("keyup", blockKeys, true); // extra safety
  //   window.addEventListener("keypress", blockKeys, true);

  //   return () => {
  //     window.removeEventListener("keydown", blockKeys, true);
  //     window.removeEventListener("keyup", blockKeys, true);
  //     window.removeEventListener("keypress", blockKeys, true);
  //   };
  // }, []);

  // useEffect(() => {
  //   const handleKeyDown = (e) => {
  //     // Block F1–F12
  //     if (e.keyCode >= 112 && e.keyCode <= 123) {
  //       e.preventDefault();
  //       e.stopPropagation();
  //       return false;
  //     }

  //     // Block Ctrl combinations
  //     if (e.ctrlKey) {
  //       e.preventDefault();
  //       e.stopPropagation();
  //       return false;
  //     }

  //     // Block Alt combinations (not 100% but helps)
  //     if (e.altKey) {
  //       e.preventDefault();
  //       e.stopPropagation();
  //       return false;
  //     }

  //     // Block Escape
  //     if (e.key === "Escape") {
  //       e.preventDefault();
  //       e.stopPropagation();
  //       return false;
  //     }

  //     if (e.ctrlKey || e.metaKey) {
  //       const blockedKeys = ["c", "v", "x", "a", "u", "s","g"];

  //       if (blockedKeys.includes(e.key.toLowerCase())) {
  //         e.preventDefault();
  //         alert("Action not allowed during exam");
  //         return;
  //       }
  //     }

  //     // Block specific keys manually
  //     const blockedKeys = [
  //       "F1",
  //       "F2",
  //       "F3",
  //       "F4",
  //       "F5",
  //       "F6",
  //       "F7",
  //       "F8",
  //       "F9",
  //       "F10",
  //       "F11",
  //       "F12",
  //       "Alt",
  //       "Meta",
  //     ];

  //     if (blockedKeys.includes(e.key)) {
  //       e.preventDefault();
  //       e.stopPropagation();
  //       return false;
  //     }
  //   };

  //   window.addEventListener("keydown", handleKeyDown, true);

  //   return () => {
  //     window.removeEventListener("keydown", handleKeyDown, true);
  //   };
  // }, []);

  // useEffect(() => {
  //   const handleBlur = () => {
  //     if (!isSubmittedRef.current) {
  //       alert("Screen change detected. Exam will be submitted.");
  //       handleSubmitFinal();
  //     }
  //   };

  //   window.addEventListener("blur", handleBlur);

  //   return () => {
  //     window.removeEventListener("blur", handleBlur);
  //   };
  // }, []);

  const [isBlurred, setIsBlurred] = useState(false);

  // useEffect(() => {
  //   const handleVisibility = () => {
  //     if (document.hidden) {
  //       setIsBlurred(true);
  //     }
  //   };

  //   document.addEventListener("visibilitychange", handleVisibility);

  //   return () => {
  //     document.removeEventListener("visibilitychange", handleVisibility);
  //   };
  // }, []);

  // useEffect(() => {
  //   const handleFocusLoss = () => {
  //     if (!document.hasFocus()) {
  //       alert("You left the exam screen ");
  //       handleSubmitFinal();
  //     }
  //   };

  //   const interval = setInterval(handleFocusLoss, 500);

  //   return () => clearInterval(interval);
  // }, []);

  // useEffect(() => {
  //   const handleFullscreenChange = () => {
  //     // ❌ If user exits fullscreen (ESC / F11 / browser control)
  //     if (!document.fullscreenElement) {
  //       handleSubmitFinal(); // ✅ AUTO SUBMIT
  //     }
  //   };

  //   document.addEventListener("fullscreenchange", handleFullscreenChange);

  //   return () => {
  //     document.removeEventListener("fullscreenchange", handleFullscreenChange);
  //   };
  // }, []);

  // useEffect(() => {
  //   const handleVisibilityChange = () => {
  //     if (document.hidden) {
  //       handleSubmitFinal(); // ✅ AUTO SUBMIT
  //     }
  //   };

  //   document.addEventListener("visibilitychange", handleVisibilityChange);

  //   return () => {
  //     document.removeEventListener("visibilitychange", handleVisibilityChange);
  //   };
  // }, []);

  useEffect(() => {
    const enterFullScreen = async () => {
      try {
        if (!document.fullscreenElement) {
          await document.documentElement.requestFullscreen();
        }
      } catch (err) {
        console.log("Fullscreen error:", err);
      }
    };

    const handleFirstInteraction = () => {
      enterFullScreen();

      document.removeEventListener("click", handleFirstInteraction);
      document.removeEventListener("keydown", handleFirstInteraction);
    };

    document.addEventListener("click", handleFirstInteraction);
    document.addEventListener("keydown", handleFirstInteraction);

    return () => {
      document.removeEventListener("click", handleFirstInteraction);
      document.removeEventListener("keydown", handleFirstInteraction);
    };
  }, []);

  {
    !isStarted && (
      <div className="start-overlay">
        <h2>Click to Start Test</h2>
        <Button onClick={startTest}>Start Test</Button>
      </div>
    );
  }

  const attemptedQuestions = all_questions?.data?.reduce(
    (result, question, index) => {
      if (question?.user_answer_id !== null) {
        result.push(index + 1);
      }
      return result;
    },
    [],
  );

  return (
    <section className="Test_Page">
      {/* <div className="container" > */}

      <div className={`container ${isBlurred ? "blur-screen" : ""}`}>
        {isQuestionsLoading ? (
          <div className="test_loader_holder">
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading questions...</span>
            </Spinner>
            <p className="mt-3 mb-0">Loading questions...</p>
          </div>
        ) : questions.length === 0 ? (
          <div className="test_loader_holder">
            <p className="text-danger mb-0" role="alert">
              {all_questions?.error || "No questions found for this test."}
            </p>
          </div>
        ) : (
          <>
        <div className="pagination_div">
          <Pagination className="test_pagination">
            <Pagination.Prev
              disabled={currentPage === 1}
              onClick={() => handlePageChange(currentPage - 1)}
            />

            {[...Array(totalPages)].map((_, index) => {
              const page = index + 1;

              const isCurrent = currentPage === page;
              const isAttempted = attemptedQuestions?.includes(page);

              return (
                <Pagination.Item
                  key={page}
                  active={isCurrent}
                  className={
                    isCurrent
                      ? "question_current"
                      : isAttempted
                      ? "question_attempted"
                      : "question_not_attempted"
                  }
                  onClick={() => handlePageChange(page)}
                >
                  {page}
                </Pagination.Item>
              );
            })}

            <Pagination.Next
              disabled={currentPage === totalPages}
              onClick={() => handlePageChange(currentPage + 1)}
            />
          </Pagination>

          <div className="question_status_legend">
            <span>
              <i className="status_dot current"></i>
              Current
            </span>

            <span>
              <i className="status_dot attempted"></i>
              Attempted
            </span>

            <span>
              <i className="status_dot not_attempted"></i>
              Not Attempted
            </span>
          </div>
        </div>

        {/* <h5 className="text-end">
          Time Left: {Math.floor(timeLeft / 60)}:
          {String(timeLeft % 60).padStart(2, "0")}
        </h5> */}
        <h5
          className="text-end"
          style={{
            color: timeLeft <= 10 ? "red" : "black",
            fontWeight: timeLeft <= 10 ? "700" : "500",
          }}
        >
          Time Left: {Math.floor(timeLeft / 60)}:
          {String(timeLeft % 60).padStart(2, "0")}
        </h5>
        <Form className="question_div" onSubmit={handleSubmit}>
          {/* {all_questions?.data?.map((q) => ( */}

          {/* {all_questions?.data?.map((q) => (
            <div className="question_card mb-4" key={q.id}> */}
          {currentQuestion && (
            <div className="question_card mb-4" key={currentQuestion.id}>
              <h5 className="question_title mb-3">
                Que {currentPage}. {currentQuestion.ExamQuestion?.question}
              </h5>

              <p>
                {answers[currentQuestion.id]
                  ? "✅ Attempted"
                  : "❌ Not Attempted"}
              </p>

              {(currentQuestion.ExamQuestion?.ExamAnswers || []).map(
                (option, index) => (
                  <div key={option.id} className="option_wrapper mb-3">
                    <div className="d-flex align-items-center">
                      <span className="me-2">{index + 1}</span>

                      <Form.Check
                        type="radio"
                        name={`question-${currentQuestion.id}`}
                        id={`q${currentQuestion.id}-o${option.id}`}
                        label={option.answer}
                        className="custom-radio"
                        onChange={() =>
                          setAnswers({
                            ...answers,
                            [currentQuestion.id]: option.id,
                          })
                        }
                        checked={answers[currentQuestion.id] === option.id}
                      />
                    </div>
                  </div>
                ),
              )}
            </div>
          )}
        </Form>
        {errorMsg && (
          <p className="text-danger" role="alert">
            {errorMsg}
          </p>
        )}
        {/* ✅ Buttons */}
        <div className="d-flex justify-content-between mb-3">
          <Common_Btn
            text="Previous"
            type="button"
            disabled={Number(currentPage) === 1}
            onClick={() => handlePageChange(currentPage - 1)}
            className={Number(currentPage) === 1 ? "next_btn" : ""}
          />

          {/* Save */}
          <span className="d-inline-flex align-items-center gap-2">
            <Common_Btn
              text={isSaving ? "Saving..." : "Save"}
              type="button"
              onClick={handleSave}
              disabled={isSaving || isPageSwitching}
            />
            {isSaving && (
              <Spinner animation="border" size="sm" role="status">
                <span className="visually-hidden">Saving...</span>
              </Spinner>
            )}
          </span>

          {
            <Common_Btn
              text="Next"
              type="button"
              disabled={Number(currentPage) === Number(totalPages)}
              onClick={() => {
                setErrorMsg("");
                handlePageChange(currentPage + 1);
              }}
              className={
                Number(currentPage) === Number(totalPages) ? "next_btn" : ""
              }
            />
          }
        </div>

        <div className="pagination_holder">
          <div>
            <Button
              onClick={() => {
                handleSubmitFinal();
              }}
              disabled={isSubmittingFinal || isSaving}
            >
              {isSubmittingFinal ? (
                <>
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    className="me-2"
                  />
                  Submitting...
                </>
              ) : (
                "Submit"
              )}
            </Button>
          </div>

          {/* ✅ Pagination */}
        </div>
          </>
        )}
      </div>
      <Success_Modal
        show={showModal}
        handleClose={() => setShowModal(false)}
        message={"Test Submitted Successfully"}
      />
    </section>
  );
};

export default Test_Page;
